import { render, staticRenderFns } from "./customerContractCreation.vue?vue&type=template&id=48dd3b12"
import script from "./customerContractCreation.vue?vue&type=script&lang=js"
export * from "./customerContractCreation.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports